export enum Weekday {
    SUNDAY = 0,
    MONDAY = 1,
    TUESDAY = 2,
    WEDNESDAY = 3,
    THURSDAY = 4,
    FRIDAY = 5,
    SATURDAY = 6,
}

export const WeekdayCopy = {
    [Weekday.SUNDAY]: "Sun",
    [Weekday.MONDAY]: "Mon",
    [Weekday.TUESDAY]: "Tue",
    [Weekday.WEDNESDAY]: "Wed",
    [Weekday.THURSDAY]: "Thu",
    [Weekday.FRIDAY]: "Fri",
    [Weekday.SATURDAY]: "Sat",
};
